export const ACTIVITY_LABELS: Record<string, string> = {
  session_start: 'Session started', page_view: 'Page viewed', listing_view: 'Listing viewed', marketplace_filter: 'Search or filter used', engagement: 'Active foreground time',
  install_prompt: 'Install prompt available', install_accepted: 'Install prompt accepted', install_dismissed: 'Install prompt dismissed', pwa_install_reported: 'Browser reported installation', pwa_launch: 'App opened', sign_out: 'Signed out',
  sign_in: 'Signed in successfully', sign_up: 'Account created', listing_created: 'Listing created', listing_updated: 'Listing updated', listing_published: 'Listing published', listing_sold: 'Listing marked sold', enquiry_sent: 'Enquiry submitted successfully', watchlist_changed: 'Watchlist changed', listing_shared: 'Listing shared',
};
export const ANALYTICS_ROLE_LABELS: Record<string, string> = {
  admin: 'Administrator', agent: 'Livestock agent', user: 'Farmer / customer', farmer: 'Farmer / customer', agronomist_admin: 'Agronomy administrator', agronomist_agent: 'Agronomy agent',
};
export const ANALYTICS_AUDIENCES = [
  { value: '', label: 'All audiences' },
  { value: 'admin', label: 'Administrator' },
  { value: 'agent', label: 'Livestock agent' },
  { value: 'farmer_customer', label: 'Farmer / customer' },
  { value: 'agronomist_admin', label: 'Agronomy administrator' },
  { value: 'agronomist_agent', label: 'Agronomy agent' },
  { value: 'anonymous', label: 'Anonymous visitors' },
];
export function analyticsUserMatches(user: { name: string; email: string; role: string }, search: string): boolean {
  return `${user.name} ${user.email} ${user.role} ${ANALYTICS_ROLE_LABELS[user.role] || ''}`.toLowerCase().includes(search.trim().toLowerCase());
}
export function safeAnalyticsPath(path: string): string {
  const pathname = path.split(/[?#]/)[0];
  return /^\/[a-zA-Z0-9_/-]{0,180}$/.test(pathname) ? pathname : '/';
}
export function shouldCountEngagement(visible: boolean, now: number, lastInteraction: number): boolean {
  return visible && now - lastInteraction <= 60_000 && now >= lastInteraction;
}
export function engagementSeconds(elapsedMs: number): number {
  return Math.min(15, Math.max(0, Math.round(elapsedMs / 1000)));
}
export function csvCell(value: unknown): string {
  let text = String(value ?? '');
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}
